import React, { useState, useEffect } from "react";
import { API, graphqlOperation, Auth } from "aws-amplify";
import {
  listCreateOrderOfBillings,
  getCreateOrderOfBilling,
} from "../../graphql/queries";

import {
  createCreateOrderOfBilling,
  updateCreateOrderOfBilling,
  deleteCreateOrderOfBilling,
} from "../../graphql/mutations";
import {
  Card,
  Modal,
  Button,
  Alert,
  Row,
  Col,
  Input,
  notification,
  Descriptions,
  Popconfirm,
  Collapse,
  Tag,
  Image,
  Select,
  Table,
  Statistic,
  Tabs,
  Checkbox,
  Radio,
} from "antd";
import { DeleteOutlined, PlusOutlined, UserOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import Dropdown from "react-bootstrap/Dropdown";
import fetchItemsNextToken from "../../function/fetchItemsNextTokenZau";
import ZauPayitem from "../../json/payitemZau.json";
import axios from "axios";

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;
const { TabPane } = Tabs;

const user = JSON.parse(localStorage.getItem("profile"));

const {
  REACT_APP_CHECK_OP,
} = process.env;



const token = localStorage.getItem("token");

const LocationClearance = (props) => {
  const [searchData, setSearchData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [viewData, setViewData] = useState(false);
  const [statusEvent, setStatusEvent] = useState(1);
  const [permitId, setPermitId] = useState();
  const [grandTotal, setGrandTotal] = useState("");
  const [opData, setOpData] = useState([]);
  const [values, setValues] = useState({
    lcNo: "",
    applicationNo: "",
    applicationCategory: "",
    projectActivity: "",
    evaluation_facts_extended: "",
    lotNo: "",
    blkNo: "",
    address: "",
    street: "",
    barangay: "",
    district: "",
    owner: "",
    zoneClassification: "",
    occupancy: "",
    lotArea: "",
    floorArea: "",
    noOfUnit: "",
    tctNo: "",
    evaluationOfFacts: "",
    oldOp: "",
  });
  const [listPayitem, setListPayitem] = useState([
    "Zoning - Application (Filling) Fee",
    "Zoning - Certification",
    "Zoning - Commercial",
    "Zoning - Fee",
    "Zoning - Industrial",
    "Zoning - Motion for Reconsideration",
    "Zoning - Others",
    "Zoning - Processing Fee",
    "Zoning - Residential",
    "Zoning - Security Seal",
    "Zoning - Surcharge",
    "Zoning - Verification Fee",
    "Zoning Fees Subdivision",
    "BP 220 Plan Approval",
    "Annual Inspection Fees - CPDO",
    "Locational Clearance of Business",
    "PD 957",
    "Processing Fee: Preliminary Plans",
    "Vertical Component",
  ]);
  const [zoneClassification, setZoneClassification] = useState([
    "Low Density Residential Zone (R-1)",
    "Low Density Residential SubZone (R-1-A)",
    "Medium Density Residential Zone (R-2)",
    "Medium Density Residential SubZone (R-2-A)",
    "High Density Residential Zone (R-3)",
    "Minor Commercial Zone (C-1)",
    "Major Commercial Zone (C-2)",
    "Metropolitan Commercial Zone (C-3)",
    "Low Intensity Industrial Zone (I-1)",
    "Medium Intensity Industrial Zone (I-2)",
    "Institutional Zone (INST)",
    "Socialized Housing Zone (SHZ)",
    "Transport and Utilities Zone (TRU)",
    "Special Urban Development Zone (SUDZ)",
    "Parks and Recreation Zone (PRZ)",
    "Cemetery (CEM)",
    "Historical Spot and Shrine (HSS)",
    "Environmental Protected Areas (EPA)",
    "Special Development Zone (SDZ)",
    "Road (R)",
    "(SUDZ) Triangle Exchange",
    "(SUDZ) Downtown Hub",
    "(SUDZ) Common",
    "(SUDZ) Emporium",
  ]);
  const [showmodalRemarks, setShowmodalRemarks] = useState(false);
  const [checkArray, setCheckedArray] = useState([
    {
      paymentitem: "",
      fees: "",
      AccountName: "",
      Accountcode: "",
      OfficeCode: "",
      surcharge: "",
      penalties: "",
      total: "",
    },
  ]);
  const [remarksArray, setRemarksArray] = useState([]);
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [files, setFiles] = useState([]);
  const [uploadFields, setUploadFields] = useState([]);
  const [applicationId, setApplicationId] = useState("");
  const [attachmentId, setAttachmentId] = useState([]);
  const [zoneClassificationMenu, setZoneClassificationMenu] = useState("");
  const [occupancy, setOccupancy] = useState("");
  const [listforApproval, setListForApproval] = useState([]);
  const [listofdenied, setListOfDenied] = useState([]);
  const [listofdivisionchiefapproval, setListOfDivisionchief] = useState([]);
  const [listofdepartmentheadapproval, setListOfDepartmentHead] = useState([]);
  const [listforpayment, setListForPayment] = useState([]);
  const [event, setEvent] = useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [forRelease, setForRelease] = useState([]);
  const [checkifhaspayitem, setCheckIfhaspayitem] = useState(false);
  const [tctNo, setctNo] = useState([""]);
  const [type, settype] = useState("LC");
  const [title, setTitle] = useState("List of Locational Permit");
  const [isHaveOlderOP, setIsHaveOlderOP] = useState(false);
  const [disabledSave, setDisabledSave] = useState(false);

  useEffect(() => {
    fetchListForApproval();
    fetchDeniedList();
    fetchDivisionApproval();
    fetchDepartmentHeadApproval();
    fetchForPayment();
    fetchListForAll();
    fetchForRelease();
  }, []);


  const fetchListForApproval = () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            typeofapplication: { ne: "COE" },
            status: { eq: "1" },
            isCleared: { ne: true },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        setListForApproval(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchListForAll = () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            isCleared: { ne: true },
            typeofapplication: { ne: "COE" },
            // ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        setSearchData(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchForRelease = () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            typeofapplication: { ne: "COE" },
            or: [{ status: { eq: "5" } }, { status: { eq: "6" } }],
            isCleared: { ne: true },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        setForRelease(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDeniedList = () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            typeofapplication: { ne: "COE" },
            isDeny: { eq: "1" },
            status: { eq: "15" },
            isCleared: { ne: true },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        setListOfDenied(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDivisionApproval = () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            typeofapplication: { ne: "COE" },
            status: { eq: "2" },
            isCleared: { ne: true },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        setListOfDivisionchief(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDepartmentHeadApproval = () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            typeofapplication: { ne: "COE" },
            status: { eq: "3" },
            isCleared: { ne: true },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        setListOfDepartmentHead(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
      });
    } catch (error) {
      console.log(error);
    }
  };

  const fetchForPayment = () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            typeofapplication: { ne: "COE" },
            status: { eq: "4" },
            isCleared: { ne: true },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        setListForPayment(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleforapproval = () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            typeofapplication: { ne: "COE" },
            status: { eq: "1" },
            isCleared: { ne: true },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        setListForApproval(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
        setSearchData(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
        setEvent(1);
        setTitle("List of New Application");
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleDenied = () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            typeofapplication: { ne: "COE" },
            isDeny: { eq: "1" },
            status: { eq: "15" },
            isCleared: { ne: true },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        setListOfDenied(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
        setSearchData(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
        setEvent(2);
        setTitle("List of Denied");
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleForRelease = () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            typeofapplication: { ne: "COE" },
            or: [{ status: { eq: "5" } }, { status: { eq: "6" } }],
            isCleared: { ne: true },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        setForRelease(
          response.sort((a, b) => new Date(a.updateAt) - new Date(b.updateAt))
        );
        setSearchData(
          response.sort((a, b) => new Date(a.updateAt) - new Date(b.updateAt))
        );
        setEvent(6);
        setTitle("List of Application for Release");
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleDivisionApproval = () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            typeofapplication: { ne: "COE" },
            status: { eq: "2" },
            isCleared: { ne: true },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        setListOfDivisionchief(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
        setSearchData(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
        setEvent(3);
        setTitle("List of Application for Recommendation");
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handlelistdepartmentapproval = () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            typeofapplication: { ne: "COE" },
            status: { eq: "3" },
            isCleared: { ne: true },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        setListOfDepartmentHead(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
        setSearchData(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
        setEvent(4);
        setTitle("List of Application for Approval");
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleListforPayment = () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            typeofapplication: { ne: "COE" },
            status: { eq: "4" },
            isCleared: { ne: true },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const a = fetchItemsNextToken(queryData);
      a.then(async (response) => {
        setListForPayment(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
        setSearchData(
          response.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
        setEvent(5);
        setTitle("List of Application for Payment");
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleShowLocationalClearance = () => {
    setIsModalVisible(true);
    setStatusEvent(1);
    if (checkArray.length === 1) {
      setCheckedArray([...checkArray]);
    } else if (checkArray.length === 0) {
      setCheckedArray([
        ...checkArray,
        {
          paymentitem: "",
          fees: "",
          surcharge: "",
          penalties: "",
          AccountName: "",
          Accountcode: "",
          OfficeCode: "",
          total: "",
        },
      ]);
    }
  };

  const handleCancelLocationClearance = () => {
    setIsModalVisible(false);
    setOccupancy("");
    setStatusEvent(1);
    setCheckedArray([]);
    setctNo([""]);
    setGrandTotal("");
    settype("");
    setValues({
      applicationNo: "",
      applicationCategory: "",
      projectActivity: "",
      evaluation_facts_extended: "",
      lotNo: "",
      blkNo: "",
      street: "",
      barangay: "",
      district: "",
      owner: "",
      zoneClassification: "",
      lotArea: "",
      floorArea: "",
      noOfUnit: "",
      tctNo: "",
      evaluationOfFacts: "",
    });
    setIsChecked(false);
    setZoneClassificationMenu([]);
    setCheckIfhaspayitem(false);
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setValues((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Are you sure you want to save this application?",
      text: "Please kindly check your input before saving it.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "OK",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          const result = API.graphql(
            graphqlOperation(createCreateOrderOfBilling, {
              input: {
                lcNo: values.lcNo,
                application_no: values.applicationNo,
                application_type: "REGULAR",
                typeofapplication: type,
                owner: values.owner,
                occupancy: occupancy,
                project_activity: values.projectActivity,
                evaluation_facts_extended: values.evaluation_facts_extended,
                address: values.address,
                Payitem: JSON.stringify(checkArray),
                isGovementInstitution: isChecked,
                isNoPaymenItem: checkifhaspayitem,
                doesHaveOldOP: isHaveOlderOP,
                opStatus: "0",
                Signature1: "0",
                Signature2: "0",
                status: "1",
                order_payment_no: isHaveOlderOP ? values.oldOp : "0",
                OrNumber: "0",
                OrDate: "0",
                deniedRemarks: JSON.stringify([]),
                deniedDate: JSON.stringify([]),
                grandTotal: grandTotal,
                lot_no: values.lotNo,
                blk_no: values.blkNo,
                location_street: values.street,
                location_barangay: values.barangay,
                location_district: values.district,
                zone_classification:zoneClassificationMenu?.filter((value) => value !== ""),
                lot_area: values.lotArea,
                floor_area: values.floorArea,
                no_of_units: values.noOfUnit,
                tct_no: tctNo,
                billing_officer:
                  user.fname + " " + user.mname + " " + user.lname,
                evaluation_facts: values.evaluationOfFacts,
                ownedBy: props.ownerId,
                division: props.division,
              },
            })
          );
          if (result) {
            Swal.fire({
              title: "Application saved successfully!",
              text: "Your application has been successfully saved.",
              icon: "success",
            }).then(() => {
              setShowmodalRemarks(false);
              setShowModalUpload(false);
              setFiles([]);
              setUploadFields([]);
              setApplicationId("");
              setViewData(false);
              setValues({
                lcNo: "",
                applicationNo: "",
                address: "",
                projectActivity: "",
                applicationCategory: "",
                lotNo: "",
                blkNo: "",
                evaluation_facts_extended: "",
                street: "",
                barangay: "",
                district: "",
                owner: "",
                zoneClassification: "",
                lotArea: "",
                floorArea: "",
                noOfUnit: "",
                tctNo: "",
                evaluationOfFacts: "",
                oldOp:""
              });
              setPermitId("");
              setGrandTotal("");
              setOpData([]);
              setctNo([""]);
              setIsModalVisible(false);
              if (event === 0 || event === 1) {
                handleforapproval();
              } else if (event === 2) {
                handleDenied();
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: `something went wrong`,
            }).then(
              () => {
                setShowmodalRemarks(false);
                setShowModalUpload(false);
                setFiles([]);
                setUploadFields([]);
                setApplicationId("");
                setViewData(false);
                setValues({
                  lcNo: "",
                  applicationNo: "",
                  address: "",
                  projectActivity: "",
                  applicationCategory: "",
                  lotNo: "",
                  blkNo: "",
                  evaluation_facts_extended: "",
                  street: "",
                  barangay: "",
                  district: "",
                  owner: "",
                  zoneClassification: "",
                  lotArea: "",
                  floorArea: "",
                  noOfUnit: "",
                  tctNo: "",
                  evaluationOfFacts: "",
                });
                setIsHaveOlderOP(false);
                setPermitId("");
                setGrandTotal("");
                setOpData([]);
                setctNo([""]);
                setIsModalVisible(false);
  
                if (event === 0 || event === 1) {
                  handleforapproval();
                } else if (event === 2) {
                  handleDenied();
                }
              }
            );
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: `${error}`,
          }).then(
            () => {
              setShowmodalRemarks(false);
              setShowModalUpload(false);
              setFiles([]);
              setUploadFields([]);
              setApplicationId("");
              setViewData(false);
              setValues({
                lcNo: "",
                applicationNo: "",
                address: "",
                projectActivity: "",
                applicationCategory: "",
                lotNo: "",
                blkNo: "",
                evaluation_facts_extended: "",
                street: "",
                barangay: "",
                district: "",
                owner: "",
                zoneClassification: "",
                lotArea: "",
                floorArea: "",
                noOfUnit: "",
                tctNo: "",
                evaluationOfFacts: "",
              });
              setIsHaveOlderOP(false);
              setPermitId("");
              setGrandTotal("");
              setOpData([]);
              setctNo([""]);
              setIsModalVisible(false);

              if (event === 0 || event === 1) {
                handleforapproval();
              } else if (event === 2) {
                handleDenied();
              }
            }
          );
        }
      }
    });
  };
  /* Not Complete(Checked setIsChecked) */
  const handleUpdateShow = (e, data) => {
    e.preventDefault();
    console.log(data);
    try {
      setIsModalVisible(true);
      setStatusEvent(2);
      setPermitId(data?.id);
      setValues({
        lcNo: data?.lcNo,
        address: data?.address,
        applicationCategory: data?.application_type,
        evaluation_facts_extended: data?.evaluation_facts_extended,
        applicationNo: data?.application_no,
        projectActivity: data?.project_activity,
        lotNo: data?.lot_no,
        blkNo: data?.blk_no,
        street: data?.location_street,
        barangay: data?.location_barangay,
        district: data?.location_district,
        owner: data?.owner,
        lotArea: data?.lot_area,
        floorArea: data?.floor_area,
        noOfUnit: data?.no_of_units,
        tctNo: data?.tct_no,
        evaluationOfFacts: data?.evaluation_facts,
        oldOp: data?.order_payment_no,
      });
      setOccupancy(data?.occupancy);
      setZoneClassificationMenu(
        data?.zone_classification.replace(/\[|\]/g, "")
      );
      isStringParsable(data?.tct_no);
      setAttachmentId(JSON.parse(data?.locations));
      setGrandTotal(data?.grandTotal);
      setIsChecked(data?.isGovementInstitution);
      setIsHaveOlderOP(data?.doesHaveOldOP);
      setCheckIfhaspayitem(data?.isNoPaymenItem);
      settype(data?.typeofapplication);
      if (JSON.parse(data?.Payitem).length === 0) {
        setCheckedArray([
          ...checkArray,
          {
            paymentitem: "",
            fees: "",
            surcharge: "",
            penalties: "",
            AccountName: "",
            Accountcode: "",
            OfficeCode: "",
            total: "",
          },
        ]);
      } else {
        setCheckedArray(JSON.parse(data?.Payitem));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const isStringParsable = (str) => {
    try {
      const array = str.split(", ").map((item) => item.replace(/[[\]]/g, ""));
      setctNo(array);
      return true;
    } catch (error) {
      const array = str.split(", ").map((item) => item.replace("&", ""));
      setctNo(array);
      return false;
    }
  };


  const handleUpdate = async (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Do you want to update this application?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "OK",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          const result = API.graphql(
            graphqlOperation(updateCreateOrderOfBilling, {
              input: {
                id: permitId,
                lcNo: values.lcNo,
                typeofapplication: type,
                application_no: values.applicationNo,
                application_type: values.applicationCategory,
                owner: values.owner,
                occupancy: occupancy,
                address: values.address,
                project_activity: values.projectActivity,
                doesHaveOldOP: isHaveOlderOP,
                lot_no: values.lotNo,
                blk_no: values.blkNo,
                Payitem: JSON.stringify(checkArray),
                isGovementInstitution: isChecked,
                isNoPaymenItem: checkifhaspayitem,
                opStatus: "0",
                Signature1: "0",
                Signature2: "0",
                order_payment_no: isHaveOlderOP ? values.oldOp : "0",
                OrNumber: "0",
                OrDate: "0",
                grandTotal: grandTotal,
                location_street: values.street,
                location_barangay: values.barangay,
                location_district: values.district,
                zone_classification: zoneClassificationMenu,
                lot_area: values.lotArea,
                floor_area: values.floorArea,
                no_of_units: values.noOfUnit,
                tct_no: tctNo,
                evaluation_facts: values.evaluationOfFacts,
                evaluation_facts_extended: values.evaluation_facts_extended,
                billing_officer:
                  user.fname + " " + user.mname + " " + user.lname,
                ownedBy: props.ownerId,
                division: props.division,
              },
            })
          );

          if (result) {
            Swal.fire("Application successfully updated!", "", "success").then(
              () => {
                setShowmodalRemarks(false);
                setShowModalUpload(false);
                setFiles([]);
                setUploadFields([]);
                setApplicationId("");
                setViewData(false);
                setValues({
                  lcNo: "",
                  applicationNo: "",
                  address: "",
                  projectActivity: "",
                  applicationCategory: "",
                  lotNo: "",
                  blkNo: "",
                  evaluation_facts_extended: "",
                  street: "",
                  barangay: "",
                  district: "",
                  owner: "",
                  zoneClassification: "",
                  lotArea: "",
                  floorArea: "",
                  noOfUnit: "",
                  tctNo: "",
                  evaluationOfFacts: "",
                });
                setIsHaveOlderOP(false);
                setPermitId("");
                setGrandTotal("");
                setOpData([]);
                setctNo([""]);
                setIsModalVisible(false);

                if (event === 0 || event === 1) {
                  handleforapproval();
                } else if (event === 2) {
                  handleDenied();
                }
              }
            );
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: `${error}`,
          }).then(
            () => {
              setShowmodalRemarks(false);
              setShowModalUpload(false);
              setFiles([]);
              setUploadFields([]);
              setApplicationId("");
              setViewData(false);
              setValues({
                lcNo: "",
                applicationNo: "",
                address: "",
                projectActivity: "",
                applicationCategory: "",
                lotNo: "",
                blkNo: "",
                evaluation_facts_extended: "",
                street: "",
                barangay: "",
                district: "",
                owner: "",
                zoneClassification: "",
                lotArea: "",
                floorArea: "",
                noOfUnit: "",
                tctNo: "",
                evaluationOfFacts: "",
              });
              setIsHaveOlderOP(false);
              setPermitId("");
              setGrandTotal("");
              setOpData([]);
              setctNo([""]);
              setIsModalVisible(false);

              if (event === 0 || event === 1) {
                handleforapproval();
              } else if (event === 2) {
                handleDenied();
              }
            }
          );
        }
      }
    });
  };

  const handleConfirmDelete = async (e, rId) => {
    e.preventDefault();
    try {
      const status = await API.graphql(
        graphqlOperation(deleteCreateOrderOfBilling, {
          input: {
            id: rId,
          },
        })
      );
      if (status) {
        notification["success"]({
          message: "Success",
          description: "Your File is successfully deleted.",
        });
        setIsModalVisible(false);
        setValues({
          lcNo: "",
          applicationNo: "",
          projectActivity: "",
          lotNo: "",
          evaluation_facts_extended: "",
          blkNo: "",
          street: "",
          barangay: "",
          district: "",
          owner: "",
          zoneClassification: "",
          lotArea: "",
          floorArea: "",
          noOfUnit: "",
          tctNo: "",
          evaluationOfFacts: "",
        });
        setOccupancy("");
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeDropdown = (e, index, name) => {
    let total = 0;
    const values = e.target !== undefined ? e.target.value : e;
    const list = [...checkArray];
    list[index][name] = values;

    if (name !== "fees") {
      list[index]["AccountName"] = ZauPayitem[values]["AccountName"];
      list[index]["Accountcode"] = ZauPayitem[values]["AccountCode"];
      list[index]["OfficeCode"] = ZauPayitem[values]["OfficeCode"];
    }
    
    const a =
      Number(list[index]["fees"]) +
      Number(list[index]["surcharge"]) +
      Number(list[index]["penalties"]);
    list[index]["total"] = a.toFixed(2);
    for (const element of list) {
      total += Number(element["total"]);
    }

    setGrandTotal(total.toFixed(2));
    setCheckedArray(list);
  };

  const handleRemoveArray = (index) => {
    let total = 0;
    const list = [...checkArray];
    let value = list[index];
    if (!listPayitem.includes(value.paymentitem)) {
      listPayitem.push(value.paymentitem);
    }
    list.splice(index, 1);
    for (const element of list) {
      total += Number(element["total"]);
    }

    const truncatedAmount = Math.floor(total * 100) / 100;
    const formattedAmount = truncatedAmount.toFixed(2);
    setGrandTotal(formattedAmount);
    setCheckedArray(list);
  };

  const handleAddArray = () => {
    const shollowCopyListPayItem = [...listPayitem]
    const payItemList = checkArray.map((item) => item.paymentitem);
    for (let i = 0; i < payItemList.length; i++) {
      for (let j = 0; j < listPayitem.length; j++) {
        if (payItemList[i] === listPayitem[j]) {
          const a = listPayitem.indexOf(listPayitem[j]);
          shollowCopyListPayItem.splice(a, 1);
        }
      }
    }

    setListPayitem(shollowCopyListPayItem);
    setCheckedArray([
      ...checkArray,
      {
        paymentitem: "",
        fees: "",
        surcharge: "",
        penalties: "",
        AccountName: "",
        Accountcode: "",
        OfficeCode: "",
        total: "",
      },
    ]);
  };

  const handlePrintLCForm = (id) => {
    let url;
    let title;
    url = "/lc-form-print?id=" + id;
    title = "Locational Form";
    const params =
      "directories=no,titlebar=no,toolbar=no,location=off," +
      "status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=800";

    window.open(url, title, params);
  };

  const handlePrintOrderOfPayment = (id) => {
    let url;
    let title;
    url = "/orderofpaymentzau-form-print?id=" + id;
    title = "Order of Payment ";
    const params =
      "directories=no,titlebar=no,toolbar=no,location=off," +
      "status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=800";

    window.open(url, title, params);
  };

  const handlePrintCOEForm = (id) => {
    let url;
    let title;
    url = "/coe-form-print?id=" + id;
    title = "Locational Form with Certificate of Exception";
    const params =
      "directories=no,titlebar=no,toolbar=no,location=off," +
      "status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=800";

    window.open(url, title, params);
  };

  const handlePrintSUPForm = (id) => {
    let url;
    let title;
    url = "/sup-form-print?id=" + id;
    title = "Locational Clearance with Special User Permit";
    const params =
      "directories=no,titlebar=no,toolbar=no,location=off," +
      "status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=800";

    window.open(url, title, params);
  };

  /* Forward function */
  const handleForwardOpstatus = async (e, data) => {
    e.preventDefault();
    try {
      Swal.fire({
        title: `Are you sure want to forward ${data.application_no}?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Forward it!",
      }).then(async (result) => {
        if (result.isConfirmed) {

          try {
            const fetchResult = await API.graphql(
              graphqlOperation(updateCreateOrderOfBilling, {
                input: {
                  id: data.id,
                  billing_officer:
                    user.fname + " " + user.mname + " " + user.lname,
                  ownedBy: props.ownerId,
                  division: props.division,
                  opStatus: "1",
                  status: "2",
                  opStatusDate1: new Date(),
                },
              })
            );
            if (fetchResult) {
              Swal.fire(
                "Forward Successful",
                "The message has been successfully forwarded to the Division Chief.",
                "success"
              ).then(() => {
                window.location.reload();
              });
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const viewLocationalClearance = (e, data) => {
    e.preventDefault();
    try {
      setAttachmentId(JSON.parse(data.locations));
      setViewData(true);
      setCheckedArray(JSON.parse(data.Payitem));
      setOpData(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseViewData = () => {
    setCheckedArray([]);
    setShowmodalRemarks(false);
    setShowModalUpload(false);
    setFiles([]);
    setUploadFields([]);
    setApplicationId("");
    setViewData(false);
    setValues({
      lcNo: "",
      applicationNo: "",
      address: "",
      projectActivity: "",
      applicationCategory: "",
      lotNo: "",
      blkNo: "",
      evaluation_facts_extended: "",
      street: "",
      barangay: "",
      district: "",
      owner: "",
      zoneClassification: "",
      lotArea: "",
      floorArea: "",
      noOfUnit: "",
      tctNo: "",
      evaluationOfFacts: "",
    });
    setPermitId("");
    setGrandTotal("");
    setOpData([]);
    setZoneClassification([]);
  };

  const handleCloseshowRemarks = () => {
    setCheckedArray([]);
    setShowmodalRemarks(false);
    setShowModalUpload(false);
    setFiles([]);
    setUploadFields([]);
    setApplicationId("");
    setZoneClassification([""]);
    setZoneClassificationMenu(null);
  };

  /* outdated */
  const handleClearApplications = (e, data) => {
    e.preventDefault();
    try {
      Swal.fire({
        title: `Are you sure you want to set this application ${data.application_no} to Cleared? ?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const fetchResult = await API.graphql(
              graphqlOperation(updateCreateOrderOfBilling, {
                input: {
                  id: data.id,
                  isCleared: true,
                  isClearedDate: new Date(),
                },
              })
            );
            if (fetchResult) {
              Swal.fire("Good job!", "Successfully Cleared", "success").then(
                () => {
                  window.location.reload();
                }
              );
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  /* outdated */
  const handleMarkAsFinish = async (e, data) => {
    e.preventDefault();
    try {
      const result = await Swal.fire({
        title: `Are you sure you want to set this application ${data.application_no} to Finished?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      });

      if (result.isConfirmed) {
        const resultFetch = await API.graphql(
          graphqlOperation(getCreateOrderOfBilling, { id: data.id })
        );

        const { locations, isNoPaymenItem: Amendment } =
          resultFetch.data.getCreateOrderOfBilling;

        if (Amendment && !locations) {
          Swal.fire({
            title:
              "Kindly attach the Request Form for Amendment file before marking as finished",
            text: "You won't be able to mark this as finished without attaching a file!",
            icon: "warning",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
          });
          return;
        }

        try {
          const fetchResult = await API.graphql(
            graphqlOperation(updateCreateOrderOfBilling, {
              input: {
                id: data.id,
                status: "6",
                signatureDate2: new Date(),
              },
            })
          );

          if (fetchResult) {
            await Swal.fire({
              title: "Success!",
              text: "Successfully Marked as Finished",
              icon: "success",
            }).then(() => {
              window.location.reload();
            });
          }
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: "An error occurred. Please try again.",
            icon: "error",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "OK",
          });
        }
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "An error occurred. Please try again.",
        icon: "error",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      });
    }
  };

  const handleShowRemarks = (e, data) => {
    e.preventDefault();
    try {
      setShowmodalRemarks(true);
      setRemarksArray(JSON.parse(data.deniedRemarks));
    } catch (error) {
      console.log("remarks array", error);
    }
  };

  const handleShowModalUpload = (e, data) => {
    e.preventDefault();
    try {
      setShowModalUpload(true);
      setApplicationId(data.id);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFileUpload = (event, index) => {
    const newFiles = [...files];
    newFiles[index] = event.target.files[0];
    setFiles(newFiles);
  };

  const handleAddUploadField = () => {
    setUploadFields([...uploadFields, {}]);
    setFiles([...files, null]);
  };

  const handleRemoveUploadField = (index) => {
    const newFields = [...uploadFields];
    newFields.splice(index, 1);
    setUploadFields(newFields);
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
  };

  const handleUpload = async (event) => {
    event.preventDefault();

    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append(`file`, files[i]);
    }

    await axios
      .post(process.env.REACT_APP_UPLOAD_FILES, formData, {
        headers: {
          Authorization: token,
        },
      })
      .then((response) => {
        try {
          return API.graphql(
            graphqlOperation(updateCreateOrderOfBilling, {
              input: {
                id: applicationId,
                locations: JSON.stringify(response.data.data),
              },
            })
          ).then((result) => {
            if (result) {
              Swal.fire({
                title: "File Uploaded",
                text: "The file has been successfully uploaded.",
                icon: "success",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "OK",
              }).then(() => {
                window.location.reload();
                setShowModalUpload(false);
                setFiles([]);
                setUploadFields([]);
                setApplicationId("");
              });
            }
          });
        } catch (error) {
          console.log(error);
        }
      });
  };
 

  // Remove generate token
  const handleCheckBillingNumberIfPaid = async (e, data) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: `${data?.application_no}?`,
      text: "Would you like to check if this application is paid and proceed with the update?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Update",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: "Checking...",
        html: '<div class="custom-loader-container"><div class="custom-loader"></div></div>',
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false, // Remove the "OK" button
      });

      try {

        if (data.order_payment_no) {

          const apiSend = {
            search_value: data.order_payment_no,
          };

          const fetchResult = await fetch(REACT_APP_CHECK_OP, {
            headers: {
              "Content-Type": "application/json",
              "authorization": token // Replace YOUR_AUTH_TOKEN with your actual token
            },
            method: "POST",
            body: JSON.stringify(apiSend),
          });

          const responseData = await fetchResult.json();

          if (responseData.data.totalRecords === 1) {
            const details = responseData.data.details;

            const promises = Object.keys(details).map(async (key) => {
              if (
                details[key].PostFlag === "V" ||
                details[key].PostFlag === "C"
              ) {
                const response = await API.graphql(
                  graphqlOperation(updateCreateOrderOfBilling, {
                    input: {
                      id: data.id,
                      OrNumber: details[key].ORNumber,
                      OrDate: details[key].OrDate,
                      isDeleted: "1",
                    },
                  })
                );

                if (response) {
                  Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "OR Number is Cancelled! Please verify the transaction at City Treasurer Office",
                  }).then((result) => {
                    window.location.reload();
                  });
                }
              } else {
                const response = await API.graphql(
                  graphqlOperation(updateCreateOrderOfBilling, {
                    input: {
                      id: data.id,
                      OrNumber: details[key].ORNumber,
                      OrDate: details[key].OrDate,
                      status: "5",
                    },
                  })
                );

                if (response) {
                  Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: response.data.updateCreateOrderOfBilling
                      .order_payment_no,
                  }).then((result) => {
                    window.location.reload();
                  });
                }
              }
            });

            await Promise.all(promises);
          } else {
            Swal.fire("Success!", "Payment is pending.", "warning");
          }
        } else {
          Swal.fire("Success!", "No Order of Payment Number!", "info");
        }
      } catch (error) {
        console.log(error);
        Swal.fire(
          "Error!",
          "An error occurred while checking the billing number.",
          "error"
        );
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      setCheckedArray([]);
      setShowmodalRemarks(false);
      setShowModalUpload(false);
      setFiles([]);
      setUploadFields([]);
      setApplicationId("");
      setViewData(false);
      setValues({
        lcNo: "",
        applicationNo: "",
        address: "",
        projectActivity: "",
        applicationCategory: "",
        lotNo: "",
        blkNo: "",
        evaluation_facts_extended: "",
        street: "",
        barangay: "",
        district: "",
        owner: "",
        zoneClassification: "",
        lotArea: "",
        floorArea: "",
        noOfUnit: "",
        tctNo: "",
        evaluationOfFacts: "",
      });
      setPermitId("");
      setGrandTotal("");
      setOpData([]);
      setZoneClassification([]);
    }
  };

  const searchdataBilling = (events) => {
    const query = events.toLowerCase(); // Convert query to lowercase for case-insensitive search
  
    const eventToListMap = {
      1: listforApproval,
      2: listofdenied,
      3: listofdivisionchiefapproval,
      4: listofdepartmentheadapproval,
      5: listforpayment,
      0: searchData,
      6: forRelease,
    };
  
    const list = eventToListMap[events] || searchData; // Default to searchData for unknown events
  
    const updatedList = list.filter((item) => {
      const applicantName = item.application_no.toLowerCase();
      const orderPaymentNo = item.owner ? item.owner.toLowerCase() : "";
      return applicantName.includes(query) || orderPaymentNo.includes(query);
    });
  
    setSearchData(updatedList);
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
    setCheckedArray([
      {
        paymentitem: "",
        fees: "",
        surcharge: "",
        penalties: "",
        AccountName: "",
        Accountcode: "",
        OfficeCode: "",
        total: "",
      },
    ]);
    setGrandTotal("");
  };

  const handleChangeNoPayitem = (e) => {
    setCheckIfhaspayitem(e.target.checked);
    setCheckedArray([
      {
        paymentitem: "",
        fees: "",
        surcharge: "",
        penalties: "",
        AccountName: "",
        Accountcode: "",
        OfficeCode: "",
        total: "",
      },
    ]);
    setGrandTotal("");
  };

  const handleChangeifHasOldOP = (e) => {
    setIsHaveOlderOP(e.target.checked);
    setCheckedArray([
      {
        paymentitem: "",
        fees: "",
        surcharge: "",
        penalties: "",
        AccountName: "",
        Accountcode: "",
        OfficeCode: "",
        total: "",
      },
    ]);
    setGrandTotal("");
  };

  const handleInputChange = (index, event) => {
    const newInputs = [...tctNo];
    console.log(tctNo)
    newInputs[index] = event.target.value;
    setctNo(newInputs);
  };

  const handleAddInput = () => {
    setctNo([...tctNo, ""]);
  };

  const handleRemoveInput = (index) => {
    const newInputs = [...tctNo];
    newInputs.splice(index, 1);
    setctNo(newInputs);
  };

  const columns = [
    {
      title: "No.",
      dataIndex: "index",
      width: 50,
      render: (text, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "Application No",
      dataIndex: "application_no",
      key: "application_no",
      width: 125,
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.application_no}
        </span>
      ),
      showOnResponse: true,
      showOnDesktop: true,
    },
    {
      title: "Owner",
      dataIndex: "owner",
      key: "owner",
      width: 220,
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.owner}
        </span>
      ),
      showOnResponse: true,
      showOnDesktop: true,
    },
    // {
    //   title: "Project Activity",
    //   dataIndex: "project_activity",
    //   key: "project_activity",
    //   width: 450,
    //   align: "center",
    //   render: (text, record) => (
    //     <span style={{ fontSize: "16px", fontWeight: "normal" }}>
    //       {record.project_activity}
    //     </span>
    //   ),
    //   showOnResponse: true,
    //   showOnDesktop: true,
    // },

    {
      title: 'Type of Application',
      width: 120,
      align: 'center',
      render: (text, record) => {
        const tagMappings = {
          'Government': { color: 'volcano', label: 'Government' },
          'Amendment': { color: 'cyan', label: 'Amendment' },
          'WithOldOP': { color: 'magenta', label: '(With old order of payment)' },
          'Regular': { color: 'volcano', label: 'Regular' },
        };
    
        let tagType = 'Regular'; // Default to Regular
    
        if (record.isGovementInstitution) {
          tagType = 'Government';
        } else if (record.isNoPaymenItem) {
          tagType = 'Amendment';
        } else if (record.doesHaveOldOP) {
          tagType = 'WithOldOP';
        }
    
        const tagInfo = tagMappings[tagType];
    
        return (
          <span style={{ fontSize: '16px', fontWeight: 'normal' }}>
            {tagInfo && (
              <Tag color={tagInfo.color}>{tagInfo.label}</Tag>
            )}
          </span>
        );
      },
      showOnResponse: true,
      showOnDesktop: true,
    },

    {
      title: 'Status',
      width: 120,
      align: 'center',
      render: (text, record) => {
        const statusInfo = {
          '1': { color: '#87d068', label: 'New Application' },
          '2': { color: '#87d068', label: 'For Recommendation' },
          '3': { color: '#87d068', label: 'For Approval' },
          '4': { color: '#87d068', label: 'For Payment' },
          '5': { color: '#87d068', label: 'Paid' },
          '6': { color: '#87d068', label: 'Release' },
          '15': { color: '#f50', label: 'Denied' },
        };
    
        const status = statusInfo[record.status];
        let statusElement = null;
    
        if (status) {
          if (status.label === 'Denied') {
            statusElement = (
              <Button onClick={(e) => handleShowRemarks(e, record)}>
                <Tag color={status.color}>{status.label}</Tag>
              </Button>
            );
          } else {
            statusElement = <Tag color={status.color}>{status.label}</Tag>;
          }
        }
    
        return (
          <span style={{ fontSize: '16px', fontWeight: 'normal' }}>
          {statusElement}
        </span>
        );
      },
      showOnResponse: true,
      showOnDesktop: true,
    },

    {
      title: "Date Created",
      dataIndex: "createdAt",
      key: "owner",
      width: 100,
      align: "center",
      render: (text, record) => {
        const date = new Date(record.createdAt);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
        const day = String(date.getDate()).padStart(2, "0");

        return (
          <span style={{ fontSize: "16px", fontWeight: "normal" }}>
            {`${year}-${month}-${day}`}
          </span>
        );
      },
      showOnResponse: true,
      showOnDesktop: true,
    },
    {
      title: "Date Updated",
      dataIndex: "updatedAt",
      key: "owner",
      width: 100,
      align: "center",
      render: (text, record) => {
        const date = new Date(record.updatedAt);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
        const day = String(date.getDate()).padStart(2, "0");

        return (
          <span style={{ fontSize: "16px", fontWeight: "normal" }}>
            {`${year}-${month}-${day}`}
          </span>
        );
      },
      showOnResponse: true,
      showOnDesktop: true,
    },

    {
      title: "",
      key: "action",
      width: 120,
      align: "center",
      render: (text, record) => (
        <div style={{ display: "block" }}>
          <Dropdown>
            <Dropdown.Toggle
              variant="warning"
              id="dropdown-basic"
              style={{ fontWeight: "bold" }}
            >
              Action
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ margin: 0 }}>
              {
                record.opStatus === "0" && record.status !== "6" && (
                  <Dropdown.Item
                    onClick={(e) => handleForwardOpstatus(e, record)}
                  >
                    Forward
                  </Dropdown.Item>
                )
              }

              <Dropdown.Item
                onClick={(e) => viewLocationalClearance(e, record)}
              >
                View
              </Dropdown.Item>

     

              {record.opStatus === "0" && record.status !== "6" && (
                <Dropdown.Item onClick={(e) => handleUpdateShow(e, record)}>
                  Update Permit Clearance
                </Dropdown.Item>
              )}

              {record.status === "4" && (
                <Dropdown.Item
                  onClick={(e) => handleCheckBillingNumberIfPaid(e, record)}
                >
                  Check if Paid
                </Dropdown.Item>
              )}

              {record.status === "6" && (
                <Dropdown.Item
                  onClick={(e) => handleClearApplications(e, record)}
                >
                  Clear Application
                </Dropdown.Item>
              )}

              {record.status === "5" && (
                <Dropdown.Item
                  onClick={(e) => handleClearApplications(e, record)}
                >
                  Clear Application
                </Dropdown.Item>
              )}

              {record.opStatus === "0" && record.status !== "6" && (
                <Popconfirm
                  placement="top"
                  title={`Are you sure to remove this?`}
                  onConfirm={(e) => handleConfirmDelete(e, record.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <button
                    type="primary"
                    style={{
                      width: "85%",
                      backgroundColor: "#FFFF",
                      textAlign: "left",
                      marginLeft: "16px",
                      fontSize: "16px",
                      outline: "none",
                      borderShadow: "none",
                    }}
                    className="btn btn-default btn-sm"
                  >
                    Remove
                  </button>
                </Popconfirm>
              )}

         
            </Dropdown.Menu>
          </Dropdown>

          {record.opStatus === "0" && record.status !== "6" && (
            <Dropdown>
              <Dropdown.Toggle
                variant="secondary"
                id="dropdown-basic"
                style={{ fontWeight: "bold", marginTop: "10px" }}
              >
                Upload Files
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ margin: 0 }}>
                <Dropdown.Item
                  onClick={(e) => handleShowModalUpload(e, record)}
                  target="_blank"
                  rel="noreferrer"
                >
                  Upload
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}

          {record.Signature1 === "1" &&
            record.Signature2 === "1" &&
            record.status !== "6" && (
              <Dropdown>
                <Dropdown.Toggle
                  variant="secondary"
                  id="dropdown-basic"
                  style={{ fontWeight: "bold", marginTop: "10px" }}
                >
                  Print
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ margin: 0 }}>
                  {record.typeofapplication !== "LCSUP" && (
                    <Dropdown.Item
                      onClick={() => handlePrintLCForm(record.id)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Locational Clearance
                    </Dropdown.Item>
                  )}

                  {record.typeofapplication === "LCSUP" && (
                    <Dropdown.Item
                      onClick={() => handlePrintSUPForm(record.id)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Locational Clearance with SUP
                    </Dropdown.Item>
                  )}

                  <Dropdown.Item
                    onClick={() => handlePrintOrderOfPayment(record.id)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Order of Payment
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}

          {record.status === "6" && (
            <Dropdown>
              <Dropdown.Toggle
                variant="secondary"
                id="dropdown-basic"
                style={{ fontWeight: "bold", marginTop: "10px" }}
              >
                Print
              </Dropdown.Toggle>

              <Dropdown.Menu style={{ margin: 0 }}>
                {record.typeofapplication !== "LCSUP" && (
                  <Dropdown.Item
                    onClick={() => handlePrintLCForm(record.id)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Locational Clearance
                  </Dropdown.Item>
                )}

                {record.typeofapplication === "LCSUP" && (
                  <Dropdown.Item
                    onClick={() => handlePrintSUPForm(record.id)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Locational Clearance with SUP
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
      ),
      showOnResponse: true,
      showOnDesktop: true,
    },
  ];

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Card
          headStyle={{ borderBottom: "1px solid" }}
          style={{
            width: "100%",
            borderRadius: "16px",
          }}
        >
          <div
            className="form-row"
            style={{
              marginBottom: "50px",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <div class="col-12 col-md-2" style={{ marginBottom: "10px" }}>
              <div onClick={handleforapproval}>
                <Card
                  hoverable
                  style={{
                    width: "100%",
                    borderRadius: "16px",
                   
                  }}
                >
                  <Statistic
                    title="New Application"
                    valueStyle={{
                      color: "#E7800F",
                    }}
                    value={listforApproval.length}
                    prefix={<UserOutlined />}
                  />
                </Card>
              </div>
            </div>
            <div class="col-12 col-md-2" style={{ marginBottom: "10px" }}>
              <div onClick={handleDenied}>
                <Card
                  hoverable
                  style={{
                    width: "100%",
                    borderRadius: "16px",
                   
                  }}
                >
                  <Statistic
                    title="Denied"
                    valueStyle={{
                      color: "#E7800F",
                    }}
                    prefix={<UserOutlined />}
                    value={listofdenied.length}
                    onClick={() => alert("x")}
                  />
                </Card>
              </div>
            </div>

            <div class="col-12 col-md-2" style={{ marginBottom: "10px" }}>
              <div onClick={handleDivisionApproval}>
                <Card
                  hoverable
                  style={{
                    width: "100%",
                    borderRadius: "16px",
                   
                  }}
                >
                  <Statistic
                    title="For Recommendation"
                    valueStyle={{
                      color: "#E7800F",
                    }}
                    prefix={<UserOutlined />}
                    value={listofdivisionchiefapproval.length}
                    onClick={() => alert("x")}
                  />
                </Card>
              </div>
            </div>

            <div class="col-12 col-md-2" style={{ marginBottom: "10px" }}>
              <div onClick={handlelistdepartmentapproval}>
                <Card
                  hoverable
                  style={{
                    width: "100%",
                    borderRadius: "16px",
                    
                  }}
                >
                  <Statistic
                    title="For Approval"
                    valueStyle={{
                      color: "#E7800F",
                    }}
                    prefix={<UserOutlined />}
                    value={listofdepartmentheadapproval.length}
                    onClick={() => alert("x")}
                  />
                </Card>
              </div>
            </div>

            <div class="col-12 col-md-2" style={{ marginBottom: "10px" }}>
              <div onClick={handleListforPayment}>
                <Card
                  hoverable
                  style={{
                    width: "100%",
                    borderRadius: "16px",
                   
                  }}
                >
                  <Statistic
                    title="For Payment"
                    valueStyle={{
                      color: "#E7800F",
                    }}
                    prefix={<UserOutlined />}
                    value={listforpayment.length}
                    onClick={() => alert("x")}
                  />
                </Card>
              </div>
            </div>

            <div class="col-12 col-md-2" style={{ marginBottom: "10px" }}>
              <div onClick={handleForRelease}>
                <Card
                  hoverable
                  style={{
                    width: "100%",
                    borderRadius: "16px",
                   
                  }}
                >
                  <Statistic
                    title="For Releasing"
                    valueStyle={{
                      color: "#E7800F",
                    }}
                    prefix={<UserOutlined />}
                    value={forRelease.length}
                    onClick={() => alert("x")}
                  />
                </Card>
              </div>
            </div>
          </div>

          <div>
            <h1
              style={{
                marginBottom: "16px",
                textAlign: "center",
                textTransform: "uppercase",
              }}
            >
              {title}
            </h1>
            <p style={{ fontSize: "16px", marginBottom: "40px" }}></p>
            <hr style={{ fontSize: "16px", marginBottom: "40px" }}/>
          </div>

          <div className="row">
            <div className="col-lg-3">
              <p style={{ textAlign: "center" }}>
                <Input
                  style={{
                    width: "100%",
                    marginBottom: "20px",
                    borderRadius: "16px",
                  }}
                  onChange={(e) => searchdataBilling(e.target.value)}
                  placeholder="Search...."
                />
              </p>
            </div>
            <div className="col-lg-7"></div>
            <div className="col-lg-2">
              <Button
                block
                onClick={handleShowLocationalClearance}
                style={{ width: "100%", borderRadius: "16px" }}
              >
                Add
              </Button>
            </div>

            <div className="col-lg-12">
              <div className="table-responsive-lg">
                <Table
                  loading={searchData.length === 0}
                  rowKey="id"
                  size="middle"
                  bordered            
                  dataSource={searchData}
                  pagination={{
                    pageSize: 10, // display 5 items per page
                    total: searchData.length, // total number of items
                  }}
                  columns={columns}
                />
              </div>
            </div>
          </div>
        </Card>

        <Modal
          visible={isModalVisible}
          width={1000}
          onCancel={handleCancelLocationClearance}
          footer={[]}
        >
          <Tabs>
            <TabPane>
              <Row gutter={[8, 8]} style={{ marginBottom: "10px" }}>
                <Col span={12}>
                  <Radio.Group onChange={(e) => settype(e.target.value)}>
                    <Radio value={type === "LC" ? type : "LC"}>LC</Radio>
                    <Radio value={type === "LCSUP" ? type : "LCSUP"}>
                      LC WITH SUP
                    </Radio>
                  </Radio.Group>
                </Col>
              </Row>
              <form onSubmit={statusEvent === 1 ? handleSubmit : handleUpdate}>
                <Row gutter={[8, 8]}>
                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        FOR OSS (ORDER OF PAYMENT)
                      </label>
                      <Select
                        className="loginInput"
                        onChange={(e) => setOccupancy(e)}
                        showSearch
                        filterOption={(input, option) =>
                          option.children.includes(input)
                        }
                        value={occupancy}
                      >
                        <Option value="1">RESIDENTIAL (x3.00)</Option>
                        <Option value="2">COMMERCIAL (x10.00)</Option>
                        <Option value="3">
                          COMMERCIAL (RENOVATION - x7.5.00)
                        </Option>
                        <Option value="4">COE FLR AREA</Option>
                        <Option value="5">INSTITUTIONAL (x8.00)</Option>
                        <Option value="6">SUP LOT AREA (x150.00)</Option>
                        <Option value="7">SUP FLOOR AREA (x150.00)</Option>
                      </Select>
                    </span>
                  </Col>
                </Row>

                <Row gutter={[8, 8]}>
                  <Col span={24}>
                    {type === "LC" ? (
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          LC No.
                        </label>
                        <Input
                          name="lcNo"
                          value={values.lcNo}
                          onChange={handleChange}
                        />
                      </span>
                    ) : type === "LCSUP" ? (
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          SUP No.
                        </label>
                        <Input
                          name="lcNo"
                          value={values.lcNo}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    ) : (
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          LC No.
                        </label>
                        <Input
                          name="lcNo"
                          value={values.lcNo}
                          onChange={handleChange}
                          required
                        />
                      </span>
                    )}
                  </Col>
                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        Application No
                      </label>
                      <Input
                        name="applicationNo"
                        value={values.applicationNo}
                        onChange={handleChange}
                        required
                      />
                    </span>
                  </Col>
                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        Owner
                      </label>
                      <Input
                        name="owner"
                        value={values.owner}
                        onChange={handleChange}
                        required
                      />
                    </span>
                  </Col>
                </Row>

                <br></br>

                <Row>
                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        Project Activity:
                      </label>
                      <TextArea
                        rows={2}
                        maxLength={5000}
                        name="projectActivity"
                        value={values.projectActivity}
                        onChange={handleChange}
                        required
                      />
                    </span>
                  </Col>
                </Row>
{/* 
                <Row>
                  <Col span={24}>
                    {type === "LC" && (
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          Project Location
                        </label>
                        <Input
                          name="address"
                          value={values.address}
                          onChange={handleChange}
                        />
                      </span>
                    )}
                  </Col>
                </Row> */}

                <br></br>
                <Row gutter={[8, 8]}>
                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        LOT NO.
                      </label>
                      <Input
                        name="lotNo"
                        value={values.lotNo}
                        onChange={handleChange}
                        required
                      />
                    </span>
                  </Col>
                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        BLK NO.
                      </label>
                      <Input
                        name="blkNo"
                        value={values.blkNo}
                        onChange={handleChange}
                        required
                      />
                    </span>
                  </Col>

                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        STREET.
                      </label>
                      <Input
                        name="street"
                        value={values.street}
                        onChange={handleChange}
                        required
                      />
                    </span>
                  </Col>

                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        Baranggay.
                      </label>
                      <Input
                        name="barangay"
                        value={values.barangay}
                        onChange={handleChange}
                        required
                      />
                    </span>
                  </Col>

                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        District.
                      </label>
                      <Input
                        name="district"
                        value={values.district}
                        onChange={handleChange}
                        required
                      />
                    </span>
                  </Col>
                </Row>

                <br></br>

                <Row gutter={[40, 40]}>
                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        Zone Classification
                      </label>
                      <Select
                        mode="multiple"
                        className="loginInput"
                        onChange={(e) => setZoneClassificationMenu(e)}
                        showSearch
                        filterOption={(input, option) =>
                          option.children.includes(input)
                        }
                        value={zoneClassificationMenu}
                      >
                        {zoneClassification?.map((item, i) => (
                          <Option value={item} key={item}>
                            {item}
                          </Option>
                        ))}
                      </Select>
                    </span>
                  </Col>

                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        Lot Area sq.m
                      </label>
                      <Input
                        type="number"
                        name="lotArea"
                        step={null}
                        value={values.lotArea}
                        onChange={handleChange}
                        required
                      />
                    </span>
                  </Col>

                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        Floor Area sq.m
                      </label>
                      <Input
                        type="number"
                        name="floorArea"
                        step={null}
                        value={values.floorArea}
                        onChange={handleChange}
                        required
                      />
                    </span>
                  </Col>

                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        No of Unit.
                      </label>
                      <Input
                        name="noOfUnit"
                        value={values.noOfUnit}
                        onChange={handleChange}
                        required
                      />
                    </span>
                  </Col>

                  <Col span={24}>
                    <span>
                      {tctNo.map((value, index) => (
                        <div key={index}>
                          <label className="loginInput-label" htmlFor="fname">
                            Tct No:
                          </label>
                          <Input
                            value={value}
                            onChange={(event) =>
                              handleInputChange(index, event)
                            }
                          />

                          {index === tctNo.length - 1 && (
                            <Button
                              onClick={handleAddInput}
                              style={{ marginTop: "10px" }}
                            >
                              Add Input
                            </Button>
                          )}

                          {index !== tctNo.length - 1 && (
                            <Button
                              onClick={() => handleRemoveInput(index)}
                              style={{ marginTop: "10px" }}
                            >
                              Remove
                            </Button>
                          )}
                        </div>
                      ))}
                    </span>
                  </Col>

                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        Evaluation Facts:
                      </label>
                      <TextArea
                        rows={2}
                        maxLength={5000}
                        value={values.evaluationOfFacts}
                        name="evaluationOfFacts"
                        onChange={handleChange}
                        required
                      />
                    </span>
                  </Col>

                  <Col span={24}>
                    <span>
                      <label className="loginInput-label" htmlFor="fname">
                        Prescriptive Notation:
                      </label>
                      <TextArea
                        rows={2}
                        maxLength={5000}
                        value={values.evaluation_facts_extended}
                        name="evaluation_facts_extended"
                        onChange={handleChange}
                      />
                    </span>
                  </Col>
                </Row>

                <br></br>

                <Row>
                  <Checkbox checked={isChecked} onChange={handleCheckboxChange}>
                    {" "}
                    Is this an application for government institution?
                  </Checkbox>
                </Row>
                <Row>
                  <Checkbox
                    checked={checkifhaspayitem}
                    onChange={handleChangeNoPayitem}
                  >
                    {" "}
                    Is this an application for Amendment?
                  </Checkbox>
                </Row>
                <Row>
                  <Checkbox
                    checked={isHaveOlderOP}
                    onChange={handleChangeifHasOldOP}
                  >
                    {" "}
                    Does this application have an old order of payment?
                  </Checkbox>
                </Row>

                <br></br>
                {isHaveOlderOP && (
                  <Row>
                    <Col span={24}>
                      <span>
                        <label className="loginInput-label" htmlFor="fname">
                          OLD Billing Number:
                        </label>
                        <TextArea
                          rows={2}
                          maxLength={5000}
                          value={values.oldOp}
                          name="oldOp"
                          onChange={handleChange}
                          required
                        />
                      </span>
                    </Col>
                  </Row>
                )}

                {!isChecked  && !isHaveOlderOP && (
                  <>
                    <Card>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="table-responsive">
                            {" "}
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th className="text-center"> Pay Item</th>
                                  <th className="text-center"> Fees </th>
                                  <th className="text-center"> Total </th>
                                  <th />
                                  <th />
                                </tr>
                              </thead>
                              <tbody>
                                {checkArray?.map((item, idx) => (
                                  <tr id="addr0" key={item}>
                                    <td>
                                      <Select
                                        style={{
                                          width: 310,
                                          marginRight: 10,
                                          marginLeft: 10,
                                          marginBottom: 20,
                                        }}
                                        placeholder="Pay Item"
                                        onChange={(e) =>
                                          handleChangeDropdown(
                                            e,
                                            idx,
                                            "paymentitem"
                                          )
                                        }
                                        showSearch
                                        filterOption={(input, option) =>
                                          option.children.includes(input)
                                        }
                                        filterSort={(optionA, optionB) =>
                                          optionA.children
                                            .toLowerCase()
                                            .localeCompare(
                                              optionB.children.toLowerCase()
                                            )
                                        }
                                        value={checkArray[idx]["paymentitem"]}
                                      >
                                        {listPayitem?.map((item, i) => (
                                          <Option value={item} key={item}>
                                            {item}
                                          </Option>
                                        ))}
                                      </Select>
                                    </td>
                                    <td>
                                      <Input
                                        className="form-control"
                                        onChange={(e) =>
                                          handleChangeDropdown(e, idx, "fees")
                                        }
                                        value={checkArray[idx]["fees"]}
                                      />
                                    </td>

                                    <td>
                                      <Input
                                        className="form-control"
                                        placeholder="Total"
                                        value={checkArray[idx]["total"]}
                                        readOnly
                                      />
                                    </td>
                                    <td>
                                      {checkArray.length !== 1 && (
                                        <Button
                                          onClick={() => handleRemoveArray(idx)}
                                        >
                                          <DeleteOutlined
                                            style={{
                                              marginRight: "10px",
                                              marginTop: "4px",
                                              cursor: "pointer",
                                            }}
                                          />
                                          Remove
                                        </Button>
                                      )}
                                    </td>
                                    <td>
                                      {checkArray.length - 1 === idx && (
                                        <Button
                                          onClick={handleAddArray}
                                          disabled={
                                            checkArray.length >= 19
                                          }
                                        >
                                          <PlusOutlined
                                            style={{
                                              marginTop: "4px",
                                              cursor: "pointer",
                                            }}
                                          />
                                          Add
                                        </Button>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="row">
                            <div className="col-lg-4"> </div>
                            <div className="col-lg-4">
                              <label
                                className="loginInput-label"
                                htmlFor="fname"
                              >
                                GrandTotal:
                              </label>
                              <Input
                                step="any"
                                type="number"
                                value={grandTotal}
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </>
                )}

                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "20px",
                    }}
                  >
                
                    {statusEvent === 1 && (
                      <div className="col-lg-12">
                        <span>
                          <button
                            type="submit"
                            className={`btn btn-${
                              disabledSave ? "danger" : "success"
                            } btn-block`}
                            disabled={disabledSave}
                          >
                            Save
                          </button>
                          <p>
                            {disabledSave &&
                              "It seems that the application number already exists."}
                          </p>
                        </span>
                      </div>
                    )}

                    {
                      statusEvent === 2 && 
                        <div className="col-lg-12">
                          <span>
                            <button type="submit" className="btn btn-success">
                              Update
                            </button>
                          </span>
                        </div>
                    }
                  </div>
                </>
              </form>
            </TabPane>
          </Tabs>
        </Modal>
        <Modal
          visible={viewData}
          width={1200}
          closable={false}
          footer={[
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button onClick={handleCloseViewData} danger>
                  Close
                </Button>
              </div>
            </>,
          ]}
        >
          <Row>
            <Col xs={24} xl={24}>
              <Card
                title={
                  !opData?.isGovementInstitution &&
                  !opData?.isNoPaymenItem &&
                  !opData?.doesHaveOldOP ? (
                    <Alert
                      style={{ fontWeight: "bold", fontSize: "16px" }}
                      message={`Billing Number: ${
                        opData?.order_payment_no !== "0"
                          ? opData.order_payment_no
                          : "Not Yet Approved"
                      }`}
                      type="info"
                    />
                  ) : null
                }
              >
                {opData?.isGovementInstitution && (
                  <Card>This application is for goverment Institution</Card>
                )}

                {opData?.isNoPaymenItem && (
                  <Card>This application is for Ammendment</Card>
                )}

                <br></br>
                <Collapse size="large" defaultActiveKey={["1", "2"]}>
                  <Panel header="Locational Details" key="1">
                    <Descriptions layout="vertical" size="middle" bordered>
                      <Descriptions.Item label="Name of Applicant">
                        <b>
                          {opData && String(opData.owner).toLocaleUpperCase()}
                        </b>
                      </Descriptions.Item>
                      <Descriptions.Item label="Project Activity">
                        <b>
                          {opData &&
                            String(opData.project_activity).toUpperCase()}
                        </b>
                      </Descriptions.Item>
                      <Descriptions.Item label="Project Location">
                        <b>
                          {opData &&
                            `${opData.lot_no}, ${opData.blk_no}, ${opData.location_street}, ${opData.location_barangay}, ${opData.location_district}, QUEZON CITY`}
                        </b>
                      </Descriptions.Item>
                      <Descriptions.Item label="Floor Area (sq.m)">
                        <b>
                          {opData && String(opData.floor_area).toUpperCase()}
                        </b>
                      </Descriptions.Item>
                      <Descriptions.Item label="Lot Area (sq.m)">
                        <b>{opData && String(opData.lot_area).toUpperCase()}</b>
                      </Descriptions.Item>
                      <Descriptions.Item label="Application No">
                        <b>
                          {opData &&
                            String(opData.application_no).toUpperCase()}
                        </b>
                      </Descriptions.Item>
                      <Descriptions.Item label="District">
                        <b>
                          {opData &&
                            String(opData.location_district).toUpperCase()}
                        </b>
                      </Descriptions.Item>

                      <Descriptions.Item label="Zone Classifications">
                        <b>
                          {String(opData.zone_classification).replace(
                            /\[|\]/g,
                            ""
                          )}
                        </b>
                      </Descriptions.Item>
                      <Descriptions.Item label="Evaluation of Facts:">
                        <b>
                          {opData &&
                            String(opData.evaluation_facts).toUpperCase()}
                        </b>
                      </Descriptions.Item>
                    </Descriptions>
                  </Panel>
                  {!opData?.isGovementInstitution ||
                    !opData?.isNoPaymenItem ||
                    (opData?.isHaveOlderOP && (
                      <Panel header="Order of Payment Details" key="2">
                        <Card type="inner" style={{ marginTop: "10px" }}>
                          <Row gutter={[8, 16]}>
                            <table className="table-responsive">
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th scope="col">Payitem</th>
                                    <th scope="col">FEES</th>
                                    <th scope="col">TOTAL</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {checkArray?.map((x, i) => (
                                    <tr key={checkArray[i]["paymentitem"]}>
                                      <td>{checkArray[i]["paymentitem"]}</td>
                                      <td>{checkArray[i]["fees"]}</td>
                                      <td>{checkArray[i]["total"]}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </table>
                          </Row>
                        </Card>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            marginTop: "30px",
                          }}
                        >
                          <Row gutter={[8, 24]}>
                            <Col span={24}>
                              <span>
                                <label
                                  className="loginInput-label"
                                  htmlFor="fname"
                                >
                                  GRAND TOTAL:
                                </label>
                                <Input
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "20px",
                                    width: "80%",
                                    display: "flex",
                                    justifyContent: "",
                                  }}
                                  value={`Php ${opData.grandTotal}`}
                                />
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </Panel>
                    ))}

                  <Panel header="Attachment" key="3">
                    {" "}
                    <Card type="inner" style={{ marginTop: "10px" }}>
                      <Row gutter={[8, 16]}>
                        <table className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th scope="col">Files</th>
                              </tr>
                            </thead>
                            <tbody>
                              {attachmentId?.map((x, i) => (
                                <tr key={x}>
                                  <td>
                                    <Image width={100} height={100} src={x} />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </table>
                      </Row>
                    </Card>
                  </Panel>
                </Collapse>
              </Card>
            </Col>
          </Row>
        </Modal>
        <Modal
          title="Upload files"
          centered
          visible={showModalUpload}
          closable={false}
          width={1000}
          footer={[
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button onClick={handleCloseshowRemarks} danger>
                  Close
                </Button>
              </div>
            </>,
          ]}
        >
          <div className="row">
            <div className="col-lg-12">
              <div className="table-responsive">
                {" "}
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th className="text-center">File</th>
                      <th className="text-center">-</th>
                    </tr>
                  </thead>
                  <tbody>
                    {uploadFields.map((field, index) => (
                      <tr id="addr0" key={field}>
                        <td>
                          <input
                            type="file"
                            className="form-control"
                            onChange={(event) => handleFileUpload(event, index)}
                          />
                        </td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm form-control"
                            onClick={() => handleRemoveUploadField(index)}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="row">
                <div className="col-lg-4">
                  <button
                    className="btn btn-success"
                    onClick={handleAddUploadField}
                  >
                    Add Upload Field
                  </button>
                </div>
                <div className="col-lg-4">
                  {uploadFields.length > 0 && (
                    <button
                      className="btn btn-secondary"
                      onClick={handleUpload}
                    >
                      Upload Files
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          title="Things to do"
          centered
          width={1000}
          visible={showmodalRemarks}
          closable={false}
          footer={[
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button onClick={handleCloseshowRemarks} danger>
                  Close
                </Button>
              </div>
            </>,
          ]}
        >
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Remarks</th>
                <th scope="col">Date</th>
                <th scope="col">Remarks By</th>
              </tr>
            </thead>
            <tbody>
              {remarksArray?.map((item, i) => (
                <tr key={item}>
                  <th scope="row">{i + 1}</th>
                  <td>{item.remarks.toLocaleUpperCase()}</td>
                  <td>
                    {new Date(item.date).toLocaleDateString("en-US") +
                      " " +
                      new Date(item.date).toLocaleTimeString("en-US")}
                  </td>
                  <td>{item.deniedBy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal>
      </div>
    </div>
  );
};

export default LocationClearance;
